import { FC, useState } from 'react';
import { Modal } from '../components/Modal';
import { AppPrincipal } from '../auth/AppPrincipal';
import { EnvConfiguration } from '../config/EnvConfiguration';
import { IonContent } from '@ionic/react';
import { UserState } from '../user/UserState';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { Spinner } from '../components/Spinner';

export type IHelperBeeModalProps = {
    isOpen: boolean;
    user: AppPrincipal;
    config: EnvConfiguration;
    closeHandler: () => void;
};

export const HelperBeeModal: FC<IHelperBeeModalProps> = ({ isOpen, user, config, closeHandler }) => {
    const userState = useInstance(UserState);
    useSubscription(() => userState);

    const [loaded, setLoaded] = useState<boolean>(false);

    return (
        <Modal
            isOpen={isOpen}
            titleColor="secondary"
            title="Innerhive’s BeeLine"
            closeHandler={closeHandler}
        >
            <IonContent>
                <iframe
                    width="100%"
                    height="100%"
                    title="HelperBee"
                    style={{border: 'none', overflow: 'hidden'}}
                    onLoad={() => setLoaded(true)}
                    src={`${config.AI_CHAT_URL}?user_id=${user.userId}&avatar=${encodeURIComponent(userState.state.pictureUrl || '')}`}
                />
                {!loaded && (
                    <Spinner centered />
                )}
            </IonContent>
        </Modal>
    );
};
